import { render, staticRenderFns } from "./FtpAccountsView.vue?vue&type=template&id=4590a7e7&"
import script from "./FtpAccountsView.vue?vue&type=script&lang=js&"
export * from "./FtpAccountsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4590a7e7')) {
      api.createRecord('4590a7e7', component.options)
    } else {
      api.reload('4590a7e7', component.options)
    }
    module.hot.accept("./FtpAccountsView.vue?vue&type=template&id=4590a7e7&", function () {
      api.rerender('4590a7e7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/services/hosting/shared/files/FtpAccountsView.vue"
export default component.exports